import { css } from 'styled-components';
import { BADGE_COLOR, BORDER_COLOR } from './tokens';
import { CFTokens } from '../../../../tokens';
import { badgeSize as getBadgeSize } from './utils';
export const badgeColor = ({ badgeColor, colorway = 'default', strength = 'strong', }) => {
    if (badgeColor)
        return CFTokens.getCFColorValue(badgeColor);
    return BADGE_COLOR[colorway][strength];
};
export const badgeSize = ({ size }) => {
    const badgeSize = getBadgeSize({ size });
    return css `
    width: ${badgeSize}px;
    height: ${badgeSize}px;
  `;
};
export const borderColor = ({ borderColor, colorway = 'default', strength = 'strong', }) => {
    if (borderColor)
        return CFTokens.getCFColorValue(borderColor);
    return BORDER_COLOR[colorway][strength];
};
